export class SignalrTimeoutError extends Error {
  constructor(messageName: string) {
    super(`SignalR message "${messageName}" timed out`);
  }
}
